import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Input from '../../../components/Input/Input';
import { Button, Grid, Typography } from '@mui/material';
import { format, startOfMonth, set, isValid } from 'date-fns';



function MyDatePicker({
    type,
    handleChangePeriod,
    endDate,
    startDate
}) {

    const formatDate = (date) => {
        if (date instanceof Date && !isNaN(date)) {
            const year = date.getFullYear();
            const month = `0${date.getMonth() + 1}`.slice(-2);
            const day = `0${date.getDate()}`.slice(-2);
            return `${year}-${month}-${day}`;
        }
        return '';
    };



    return (
        <>
            <Grid style={{
                width: '95%',
                marginTop: '-5x',
                marginLeft: '10px',
                border: '1px solid #ccc',
                borderRadius: '20px',
                padding: '5px',
                height: '70%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#ebebeb'
            }}>
                <Input
                    elementType="dateTimePicker"
                    label={type == 'Início' ? "Início do período" : "Fim do período"}
                    margin="normal"
                    value={type == 'Início' ? startDate : endDate}
                    onChange={(event) => handleChangePeriod(type, event)}
                />
            </Grid>
        </>
    );
}

export default MyDatePicker;
